import { Spinner } from 'components/Elements';
import { MainLayout } from 'components/Layout';
import { lazyImport } from 'utils/lazyImport';
import { Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const { OverviewRoutes } = lazyImport(() => import('features/overview'), 'OverviewRoutes');
const { CurrenciesRoutes } = lazyImport(() => import('features/currencies'), 'CurrenciesRoutes');
const { SwapRatesRoutes } = lazyImport(() => import('features/swapRates'), 'SwapRatesRoutes');
const { PaymentMethodsRoutes } = lazyImport(() => import('features/paymentMethods'), 'PaymentMethodsRoutes');

const App = () => {
  return (
    <MainLayout>
      <Suspense
        fallback={
          <div className="h-full w-full flex items-center justify-center">
            <Spinner size="xl" />
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </MainLayout>
  );
};

export const protectedRoutes = [
  {
    path: '/app',
    element: <App />,
    children: [
      { path: '/app/', element: <OverviewRoutes /> },
      { path: '/app/currencies/*', element: <CurrenciesRoutes /> },
      { path: '/app/swap-rates/*', element: <SwapRatesRoutes /> },
      { path: '/app/payment-methods/*', element: <PaymentMethodsRoutes /> },
      { path: '*', element: <Navigate to="." /> },
    ],
  },
];
